import Layout from "../UI/Layout/Layout";
import Hero from "./Hero";
import hero1 from "../../assets/image/home/hero/hero1.webp";
import hero2 from "../../assets/image/home/hero/hero2.webp";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import Intro from "./Intro/Intro";
import Fachgebiete from "./Fachgebiete/Fachgebiete";
import Checklist from "./Checklist/Checklist";
import Contact from "../Contact/ContactSection/ContactSection";
import Team from "../Lawyers/Team/Team";
import logo from "../../assets/image/logo/logo_white.svg";
import Seo from "../UI/Seo/Seo";

const Home = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Layout authLevelRequired={false}>
      <Seo
        title="Wilms Rechtsanwälte – Kanzlei in Berlin-Tempelhof"
        titleOverride
        description="Seit über 25 Jahren unterstützen wir in unserer multidisziplinären Kanzlei in Berlin-Tempelhof kleine und mittelständische Unternehmen, Freiberufler:innen und Verbraucher:innen."
        path="/"
      />
      <div>
        <Hero
          image={[hero1, hero2]}
          subtitle={t.home.hero.subtitle}
          cta={t.home.hero.cta}
          ctaLink={"/rechtsanwaelte"}
          logo={logo}
        />
        <Intro />
        <Fachgebiete />
        <Team limit={8} />
        <Checklist />
        <Contact />
      </div>
    </Layout>
  );
};

export default Home;
